import { Component, Vue, Emit } from "vue-property-decorator";
import MyButton from "@/components/MyButton.vue";
import { AuthResult } from '../../models/authResult';
import { AuthUtils } from '../../utils/authUtils';
import { MsalResult, AccessTokenStatus, ApiResult } from '../../enums';
import { Consts } from '@/consts';
import { GraphApiUtils } from '@/utils/graphApiUtils';
import { UserUtils } from '@/utils/userUtils';
import { GroupUtils } from '@/utils/groupUtils';
import { AppConfig } from '@/app-config';
import { Group } from '@/models/group';
import { AppUtils } from '@/utils/appUtils';
import { Groups } from '@/models/groups';
@Component({
	components: {
		MyButton
	}
})
export default class UserHome extends Vue {
	private title: string = '「地域人材育成のために」';
	private caption: string =
		"地域観光をリードする人材の育成を行うためのオンラインスクールシステムです。";
	private description: string =
		"メール宛に案内したOffice365アカウント情報にてログインしてください。";
	private buttonTitle: string = "はじめる";
	private buttonDisabled: boolean = true;
	private buttonClassName: string = "user-home";

	@Emit("update-user-home")
	public updateUserHome(displayName: string, groups: Groups): void { }

	public async created(): Promise<void> {
		// ログイン画面ではアクセストークンのステータスに応じて新規取得、再取得、自動リダイレクトを行う。
		// 自動リダイレクトはAADのログイン状態によっては再ログイン操作が不要の場合がある。
		let accessTokenStatus = await GraphApiUtils.getAccessTokenStatus(Vue.$accessTokenInfo);
		switch (accessTokenStatus) {
			case AccessTokenStatus.EmptyOrUndefined:
				const authResult: AuthResult = await AuthUtils.acquireTokenSilent(Vue.$userAgentApplication);
				if (authResult.result !== MsalResult.Success) {
					AppUtils.removeAccessTokenInfo();
					this.buttonDisabled = false;
					return;
				}
				AppUtils.setAccessTokenInfo(authResult.accessTokenInfo);
				accessTokenStatus = AccessTokenStatus.Valid;
				break;
			case AccessTokenStatus.Expired:
			case AccessTokenStatus.AuthenticationError:
			case AccessTokenStatus.InvalidAuthenticationToken:
				// バックグラウンドでの取得を試みる。
				const silentResult: AuthResult = await AuthUtils.acquireTokenSilent(Vue.$userAgentApplication);
				if (silentResult.result !== MsalResult.Success) {
					// 無効なアクセストークンをストレージから削除し、その状態でリダイレクトによる認証を行う。
					AppUtils.removeAccessTokenInfo();
					const authRedirectResult: AuthResult = await AuthUtils.authenticateRedirect(Vue.$userAgentApplication);
					if (authRedirectResult.result !== MsalResult.RedirectingToLogin) {
						console.error(authRedirectResult);
						this.buttonDisabled = false;
					}
				} else {
					AppUtils.setAccessTokenInfo(silentResult.accessTokenInfo);
					accessTokenStatus = AccessTokenStatus.Valid;
				}
				break;
			default:
				break;
		}
		if (accessTokenStatus !== AccessTokenStatus.Valid) {
			this.buttonDisabled = false;
			return;
		}
		const accessToken: string = Vue.$accessTokenInfo.token;
		// Userの取得
		const userResult = await UserUtils.GetMe(accessToken);
		if (userResult.result !== ApiResult.Success) {
			this.buttonDisabled = false;
			return;
		}
		const user = userResult.value;
		if (user === null) {
			this.buttonDisabled = false;
			return;
		}
		localStorage.setItem(Consts.LOCAL_STORAGE_KEY_USER_ID, user.id);
		localStorage.setItem(Consts.LOCAL_STORAGE_KEY_USER_DISPLAYNAME, user.displayName);

		const teamsResult = await GroupUtils.GetJoinedTeams(accessToken);
		if ((teamsResult.result !== ApiResult.Success) || (teamsResult.value === null)) {
			return;
		}
		// Teamの取得
		const teams: Groups = teamsResult.value;
		const groupId: string | null = localStorage.getItem(Consts.LOCAL_STORAGE_KEY_USER_GROUPID);
		if ((groupId !== null) && GroupUtils.IsPermitted(groupId)) {
			// キャッシュを利用する
			const permittedTeams: Groups = GroupUtils.GetPermittedGroups(teams);
			if (permittedTeams.value.length > 0) {
				const defaultTeam = permittedTeams.value[0];
				permittedTeams.value = [defaultTeam];
				this.updateUserHome(user.displayName, permittedTeams);
				this.$router.push(Consts.PATH_USER_CHANNELS);
			} else {
				// メンバー外の可能性あり TODOメッセージ表示
				localStorage.removeItem(Consts.LOCAL_STORAGE_KEY_USER_GROUPID);
			}
		} else {
			const permittedTeams: Groups = GroupUtils.GetPermittedGroups(teams);
			if (permittedTeams.value.length > 0) {
				const defaultTeam = permittedTeams.value[0];
				localStorage.setItem(Consts.LOCAL_STORAGE_KEY_USER_GROUPID, defaultTeam.id);
				permittedTeams.value = [defaultTeam];
				this.updateUserHome(user.displayName, permittedTeams);
				this.$router.push(Consts.PATH_USER_CHANNELS);
			} else {
				// TODOメッセージ表示
			}
		}
	}

	public async mounted(): Promise<void> {
	}

	public async updated(): Promise<void> {
	}

	public async onLoginButtonClick(e: Event): Promise<void> {
		// TODO ここでは明示的なログアウト操作を経ずにログインを試みるためサービス外でのユーザー情報の変更などを検知できない可能性がある。
		const authResult: AuthResult = await AuthUtils.authenticateRedirect(Vue.$userAgentApplication);
		if (authResult.result !== MsalResult.RedirectingToLogin) {
			alert('ログインできませんでした。');
			console.error(authResult);
			this.buttonDisabled = false;
			return;
		}
		this.buttonDisabled = true;
	}
}
